export default "__VITE_ASSET__C71B71gP__"